import $ from 'jquery';

export function showProgressMessage() {
  // If vertical scroll bar appear, then we have to move scroll on top to show splash progress in center.
  $('html, body').animate({scrollTop: 0}, 100);
  $('body').append("<div id='White_Overlay'>&nbsp;</div>");
  $('#White_Overlay')
    .css({
      opacity: 1,
      position: 'absolute',
      top: $('body').offset().top,
      left: $('body').offset().left,
      backgroundcolor: 'white',
      width: $('body').width(),
      height: $('body').height(),
      zindex: 6000
    });
  $('#optinSplash').css('display', 'block');
  $('#optinSplash').css('visibility', 'visible');
  $('#optinSplash').focus();
}

export function hideProgressMessage() {
  $('#White_Overlay').remove();
  $('#optinSplash').css('display', 'none');
  $('#optinSplash').css('visibility', 'hidden');
}
